export { default } from './ActivityList';
